'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = immutableRenderDecorator;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _shouldComponentUpdate = require('./shouldComponentUpdate');

var _shouldComponentUpdate2 = _interopRequireDefault(_shouldComponentUpdate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Makes the given component "pure".
 *
 * @param object Target Component.
 */
function immutableRenderDecorator(Target) {
  var Wrapper = function (_Component) {
    _inherits(Wrapper, _Component);

    function Wrapper() {
      _classCallCheck(this, Wrapper);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(Wrapper).apply(this, arguments));
    }

    _createClass(Wrapper, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Target, this.props, this.props.children);
      }
    }]);

    return Wrapper;
  }(_react.Component);

  Wrapper.prototype.shouldComponentUpdate = _shouldComponentUpdate2.default;

  return Wrapper;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-immutable-render-mixin/lib/immutableRenderDecorator.js
// module id = 824
// module chunks = 1 2